import { classifyImplementationName } from '@playcastdotio/PeerCore';
import type { GuestStatsSample, StreamDebugOverlaySnapshot } from '@playcastdotio/PeerCore';

type StatsFeed = { latest(): GuestStatsSample | undefined; subscribe(listener: (sample: GuestStatsSample) => void): () => void };
const empty = (): StreamDebugOverlaySnapshot => ({ codecKind: 'unknown', framesPerSecond: 0, frameWidth: 0, frameHeight: 0 });

/** Existing debug views subscribe here; this service never invokes getStats. */
export class GuestStatsSnapshotService {
  private snapshot = empty();
  private unsubscribe: (() => void) | undefined;
  private readonly listeners = new Set<(snapshot: StreamDebugOverlaySnapshot) => void>();
  bind(feed: StatsFeed | null): void {
    this.unsubscribe?.(); this.unsubscribe = undefined; this.snapshot = empty();
    if (feed) {
      const sample = feed.latest(); if (sample) this.observe(sample);
      this.unsubscribe = feed.subscribe((next) => this.observe(next));
    }
    this.publish();
  }
  latest(): StreamDebugOverlaySnapshot { return { ...this.snapshot }; }
  subscribe(listener: (snapshot: StreamDebugOverlaySnapshot) => void): () => void {
    this.listeners.add(listener); return () => { this.listeners.delete(listener); };
  }
  dispose(): void { this.bind(null); this.listeners.clear(); }
  private observe(sample: GuestStatsSample): void {
    this.snapshot = { codecKind: classifyImplementationName(sample.wire.decoderImplementation),
      framesPerSecond: sample.wire.decodeFps ?? 0, frameWidth: sample.wire.frameWidth ?? 0,
      frameHeight: sample.wire.frameHeight ?? 0, implementation: sample.wire.decoderImplementation };
    this.publish();
  }
  private publish(): void {
    for (const listener of this.listeners) { try { listener(this.latest()); } catch { /* View subscription is optional. */ } }
  }
}
export const guestStatsSnapshotService = new GuestStatsSnapshotService();
